<template lang="html">
  <div class="row">
    <div
      v-if="$store.getters.roleID === Roles.SUPER_ADMIN"
      class="col-lg-6 lbv-engineer-booking"
    >
      <b-card header="Book Engineer">
        <div class="form-row">
          <b-btn
            :disabled="!leakStatusLeaking"
            variant="primary"
            @click="book"
          >
            Book Engineer
          </b-btn>
        </div>
        <div
          v-if="showBookingForm"
          class="form-row"
        >
          <b-card
            header="Engineer Booking Form"
            class="booking-form"
          >
            <b-container fluid>
              <b-form>
                <b-form-row>
                  <b-col
                    sm="4"
                    align-self="center"
                  >
                    <label for="bookDate">Date</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input
                      id="bookDate"
                      v-model="date"
                      type="date"
                      :min="getMinDate"
                      :max="getMaxDate"
                      :disabled="!formEnabled"
                    />
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col
                    sm="4"
                    align-self="center"
                  >
                    <label for="bookTime">Time</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input
                      id="bookTime"
                      v-model="time"
                      type="time"
                      :disabled="!formEnabled"
                    />
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col
                    sm="4"
                    align-self="center"
                  >
                    <label for="bookRegion">Region</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-select
                      id="bookRegion"
                      v-model="selectedRegion"
                      :options="regions"
                      type="time"
                      :disabled="!formEnabled"
                    />
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col
                    sm="4"
                    align-self="center"
                  >
                    <label for="bookName">Primary Eng Name</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input
                      id="bookName"
                      v-model="engName"
                      type="text"
                      :disabled="!formEnabled"
                    />
                  </b-col>
                </b-form-row>

                <b-form-row class="book-form-buttons">
                  <b-btn
                    v-if="formEnabled"
                    variant="primary"
                    @click="validate"
                  >
                    Save
                  </b-btn>
                  <b-btn
                    v-if="bookingExists && !formEnabled"
                    variant="secondary"
                    @click="editBooking"
                  >
                    Edit
                  </b-btn>
                  <b-btn
                    v-if="bookingExists"
                    variant="danger"
                    @click="cancel"
                  >
                    {{ cancelLabel }}
                  </b-btn>
                </b-form-row>
              </b-form>
            </b-container>
            <b-modal
              id="confirm-booking"
              ref="confirmBooking"
              title="Confirm booking details"
              ok-variant="primary"
              ok-title="Confirm Booking"
              cancel-variant="secondary"
              cancel-title="Cancel"
              @ok="save"
            >
              <p>
                Please confirm the information is correct and the time has been
                populated in the customers time zone
              </p>
              <p>Date: <strong>{{ date }}</strong></p>
              <p>Time: <strong>{{ time }}</strong></p>
              <p>Country: <strong>{{ selectedRegion }}</strong></p>
              <p>Engineer Name: <strong>{{ engName }}</strong></p>
            </b-modal>
            <b-modal
              id="confirm-cancel"
              ref="confirmCancel"
              title="Cancel Booking"
              ok-variant="danger"
              ok-title="Confirm Cancellation"
              cancel-variant="secondary"
              cancel-title="Cancel"
              @ok="cancelBooking"
            >
              <p>
                <strong>Please confirm the engineer visit is no longer required,
                  a cancel will result in an account status change</strong>
              </p>
            </b-modal>
          </b-card>
        </div>
      </b-card>
    </div>
    <div class="col-lg-6 lbv-engineer-booking">
      <b-card header="Mark as engineer repaired">
        <div class="form-row">
          <!-- v-if="repairedLeakStatusLeaking"-->
          <b-btn
            ref="repairedBtn"
            v-b-modal.confirm-repaired
            variant="primary"
            :disabled="!leakStatusLeaking"
          >
            Leak Repaired
          </b-btn>
        </div>
        <b-modal
          id="confirm-repaired"
          title="Confirm repaired"
          ok-variant="danger"
          ok-title="Mark as repaired"
          cancel-variant="primary"
          cancel-title="Cancel"
          @ok="markAsRepaired"
        >
          <p><strong>This change cannot be undone.</strong></p>
          <p>Has this leak been confirmed repaired?</p>
        </b-modal>
      </b-card>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../event-bus.js'
import { StatusBarEvent } from '../../events/statusBarEvent'
import { APIEvent } from '../../events/apiEvent'
import { TabNavEvent } from '../../events/tabNavEvent'
import { LEAK_STATUS } from '../../constants/deviceStatus/deviceStatus'
import { mapGetters } from 'vuex'
import * as Roles from '../../constants/roles.js'

export default {
  name: 'EngineerBookingView',
  props: ['lb_id', 'leakStatus', 'leakbotId'],
  data () {
    return {
      date: '',
      time: '',
      selectedRegion: null,
      engName: '',
      showBookingForm: false,
      bookingExists: false,
      formEnabled: true,
      cancelButtonLabel: 'Cancel Booking',
      updateLeakStatus: false,
      Roles: Roles,
      regions: [
        {
          value: null,
          text: 'Please select...',
          disabled: true
        },
        {
          value: 'GBR',
          text: 'Great Britain'
        },
        {
          value: 'DNK',
          text: 'Denmark'
        },
        {
          value: 'NLD',
          text: 'Netherlands'
        },
        {
          value: 'USA',
          text: 'United States of America'
        }
      ]
    }
  },
  mounted () {
    EventBus.$on(TabNavEvent.ENG_BOOKING, this.init)
  },
  destroyed () {
    EventBus.$off(TabNavEvent.ENG_BOOKING)
  },
  computed: {
    cancelLabel: function () {
      // change label depending whether in edit mode or not
      return this.formEnabled ? 'Cancel' : 'Cancel Booking'
    },
    leakStatusLeaking: function () {
      return this.leakStatus === LEAK_STATUS.LEAK ||
      this.leakStatus === LEAK_STATUS.LEAK_ENG_VISIT ||
      this.leakStatus === LEAK_STATUS.CUST_REPAIRED_FAILED ||
      this.leakStatus === LEAK_STATUS.FAILED_REPAIR ||
      this.leakStatus === LEAK_STATUS.ENG_VISIT_NO_LEAK
    },
    getMinDate: function () {
      return new Date().toJSON().split('T')[0]
    },
    getMaxDate: function () {
      let maxDaysMS = 90 * 86400 * 1000
      let maxDateMS = new Date().getTime() + maxDaysMS
      return new Date(maxDateMS).toJSON().split('T')[0]
    },
    ...mapGetters([
      'roleID'
    ])
  },
  methods: {
    init: function () {
      // only enable booking form if in Leak True
      if (this.leakStatusLeaking) {
        this.checkForExistingBooking()
        if (this.leakStatus === LEAK_STATUS.ENG_VISIT_NO_LEAK) {
          this.$refs.repairedBtn.disabled = true
        }
      }
    },
    checkForExistingBooking: function () {
      let options = {'lbdevice_id': this.lb_id}
      console.log(options)
      this.$store.dispatch(APIEvent.FETCH_ENG_BOOKING, options)
        .then((res) => {
          if (typeof res.data.booking_id !== 'undefined') {
            this.bookingExists = true
            this.formEnabled = false
            let data = res.data
            let dateTimeRaw = data.datetime.split(' ')
            this.selectedRegion = data.country_code
            this.date = dateTimeRaw[0]
            this.time = dateTimeRaw[1]
            this.engName = data.engineer_name
            this.booking_id = data.booking_id
            this.book()
          }
        })
        .catch(this.handleError)
    },
    book: function () {
      this.showBookingForm = true
    },
    editBooking: function () {
      this.formEnabled = true
    },
    validate: function () {
      if (this.formIsValid()) {
        this.$refs.confirmBooking.show()
      } else {
        this.showValidationError()
      }
    },
    save: function () {
      if (this.formIsValid()) {
        let options = {}
        let event = ''
        // API params differ based on CREATE vs EDIT https://gph.is/2pbhdJ3
        if (this.bookingExists) {
          // edit the booking
          event = APIEvent.EDIT_ENG_BOOKING
          options.booking_id = this.booking_id
          options.country_code = this.selectedRegion
          options.engineer_name = this.engName
          options.datetime = this.date + ' ' + this.time
          let timeOption = options.datetime.split(' ')
          let timeArray = timeOption[1].split(':')
          if (timeArray[2] && timeArray[2] === '00') {
            options.datetime = this.date + ' ' + this.time
          } else { options.datetime = this.date + ' ' + this.time + ':00' }
        } else {
          // create new booking
          event = APIEvent.CREATE_ENG_BOOKING
          options.lbdevice_id = this.lb_id
          options.country = this.selectedRegion
          options.datetime = this.date + ' ' + this.time + ':00'
          options.eng_name = this.engName
        }
        this.$store.dispatch(event, options)
          .then((res) => {
            this.bookingExists = true
            this.formEnabled = false
            EventBus.$emit(StatusBarEvent.SUCCESS, 'Booking made successfully')
          })
          .catch(this.handleError)
      } else {
        this.showValidationError()
      }
    },
    showValidationError: function () {
      let dv = this.dateIsValid()
      if (!dv.valid) {
        EventBus.$emit(StatusBarEvent.WARNING, dv.failure)
        return
      }
      EventBus.$emit(StatusBarEvent.WARNING, 'Validation Error: All fields are required')
    },
    formIsValid: function () {
      // basic form validation for empty strings
      let nameValid = this.engName !== ''
      let timeValid = this.time !== ''
      let dateValid = this.date !== ''
      let regionValid = this.selectedRegion !== null
      return nameValid && timeValid && dateValid && regionValid && this.dateIsValid().valid
    },
    dateIsValid: function () {
      let minDate = new Date().getTime()
      // 90 days is arbitrary - could this be the tenant grace period?
      let maxDate = new Date().getTime() + (86400 * 90 * 1000)
      let selectedDate = new Date(this.date).getTime()
      let valid = true
      let failure = ''
      if (minDate > selectedDate && (new Date().toDateString() !== new Date(this.date).toDateString())) {
        valid = false
        failure = 'The date cannot be in the past'
      }
      if (selectedDate > maxDate) {
        valid = false
        failure = 'The date cannot be more than 90 days in the future'
      }
      return {valid, failure}
    },
    cancel: function () {
      if (this.formEnabled) {
        // reset changes by requesting booking again
        this.checkForExistingBooking()
      } else {
        // show cancel confirmation modal
        this.$refs.confirmCancel.show()
      }
    },
    cancelBooking: function () {
      // cancel the booking through the API
      let options = {booking_id: this.booking_id}
      this.$store.dispatch(APIEvent.CANCEL_ENG_BOOKING, options)
        .then((res) => {
          if (res.data.ack) {
            if (this.leakStatus === LEAK_STATUS.ENG_VISIT_NO_LEAK) {
              this.updateLeakStatus = true
              EventBus.$emit('update-leak-status', this.updateLeakStatus)
            }
            this.showBookingForm = false
          }
        })
        .catch(this.handleError)
    },
    markAsRepaired: function () {
      let options = {leakbotId: this.leakbotId}
      this.$store.dispatch(APIEvent.MARK_REPAIRED, options)
        .then(() => {
          this.checkForExistingBooking()
        })
        .catch(this.handleError)
    },
    handleError: function (error) {
      // don't display no engineer booking found error - 1607
      if (error.error !== 1607) {
        EventBus.$emit(StatusBarEvent.ERROR, error.message)
      }
    }
  }
}
</script>

<style scoped lang="css">
  .form-row .booking-form {
    width: 100%;
  }

  .form-row .book-form-buttons {
    margin-top: 40px;
  }

  .book-form-buttons button {
    margin-right: 20px;
  }

</style>
